const DONATE_URL = "https://www.maplegrovepermaculture.com/donate";
const ETRANSFER_EMAIL = "maplegrovepermaculture@gmail.com";

const formatAmount = (amountPaid) => {
  if (amountPaid == null || amountPaid <= 0) {
    return null;
  }
  return `$${Number(amountPaid).toFixed(2)}`;
};

const buildEtransferPendingSection = (formattedAmount, afterPaymentNote = "") => {
  const followUp = afterPaymentNote ? `\n\n${afterPaymentNote}` : "";

  return `💲 About Payment  
To complete your booking, please send an e-transfer of ${formattedAmount} to ${ETRANSFER_EMAIL}. We are still waiting on this payment.

If payment is not received within 24 hours, the booking will be cancelled.${followUp}`;
};

const buildGiftEconomyDonationNote = () =>
  `After your stay we kindly ask for an optional **donation** to help us maintain the space for everyone. If you'd like to donate online, visit ${DONATE_URL}. If you would like to offer your donation through work-exchange (helping on the land) please let us know in advance. There is generally something to do (wood stacking, garden weeding, brush moving, cleaning, painting or building) but please reach out in advance so we can arrange this.

Your support makes it possible to keep offering this unique experience — thank you in advance!`;

const buildPaymentSection = (pricingModel, amountPaid, paymentMethod = "none") => {
  const formattedAmount = formatAmount(amountPaid);
  const hasUpfrontCharge = formattedAmount != null;
  const isCredit = paymentMethod === "credit";
  const isEtransfer = paymentMethod === "etransfer";

  if (pricingModel === "fixed_nightly" && hasUpfrontCharge) {
    if (isCredit) {
      return `💲 About Payment  
Your stay has been **paid in full** (${formattedAmount}). No additional payment is required.

If you need to cancel, please reach out as soon as possible. Refunds are available up to 24 hours before your 2pm check-in time.`;
    }

    if (isEtransfer) {
      return buildEtransferPendingSection(formattedAmount);
    }
  }

  if (hasUpfrontCharge) {
    if (isCredit) {
      return `💲 About Payment  
Your cleaning/booking fee has been received (${formattedAmount}). ${buildGiftEconomyDonationNote()}`;
    }

    if (isEtransfer) {
      return buildEtransferPendingSection(
        formattedAmount,
        buildGiftEconomyDonationNote(),
      );
    }
  }

  return `💲 About Payment  
We don't require upfront payment. Instead, after your stay we kindly ask for a **donation** to help us maintain the space for everyone. If you'd like to donate online, visit ${DONATE_URL}. If you would like to offer your donation through work-exchange (helping on the land) please let us know in advance. There is generally something to do (wood stacking, garden weeding, brush moving, cleaning, painting or building) but please reach out in advance so we can arrange this.

Your support makes it possible to keep offering this unique experience — thank you in advance!`;
};

const PROPERTY_CONTENT = {
  Dome: {
    title: "Dome Home",
    warmth: "dome",
    access: `🔑   Access: Driving along Lawrence rd, pass our farmhouse and down the hill until you see a greenhouse. Turn in there and around the red shipping container until you see the dome. Park anywhere there. And remember to take your shoes off inside.`,
  },
  Yurt: {
    title: "Forest Yurt",
    warmth: "yurt",
    access: `🔑   Access: Driving along Lawrence rd, pass our farmhouse and down the hill until you see a greenhouse. Turn in there and you'll see a sign for yurt parking on the right (across from the red shipping container). After parking you can walk across the bridge and to the left, following the path into the trees and you'll find the yurt.`,
  },
};

const buildMessage = (rentalName, pricingModel, amountPaid, paymentMethod) => {
  const property = PROPERTY_CONTENT[rentalName] || PROPERTY_CONTENT.Dome;

  return `
Thank you for booking your stay in our ${property.title} ~ we're excited to host you!

Here are a few important details about your reservation:

When you have an idea of your arrival time, just let us know—we'll do our best to greet you in person! If possible, we'll also get a fire started so the ${property.warmth} is warm and cozy when you arrive.

📍   Location: 47 Lawrence rd, Upper Kennetcook. NS 
📅   Check In: Anytime after 2pm 
📅   Check Out: Before 11am
${property.access}
🐾   Pets: Welcome! (but not on the bed please!)

---

📜 A Few Simple Guidelines  
To keep the space comfortable and available for future guests:  
- Please let us know asap if your plans change.
- Treat the space with care and respect.
- Smoking outside only. Look for a jar for butts.
---

${buildPaymentSection(pricingModel, amountPaid, paymentMethod)}

---

We look forward to welcoming you. If you have any questions before your stay, just reply to this email. Or call 902 237 9291.

Warm regards,  
Aaron & Family
`;
};

export const getConfirmationMessage = (
  rentalName,
  pricingModel = "gift_economy",
  amountPaid = 0,
  paymentMethod = "none",
) => {
  return buildMessage(rentalName, pricingModel, amountPaid, paymentMethod);
};
